preventSectionDataLoad